<template>
  <div>
    <div class="login-container">
      <el-image :src="logo" fit="contain" style="background-color: #e1edfd; width: 400px; height: 100%"></el-image>
      <div class="login-form">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" style="margin: 0 auto">
          <p style="text-align: center; font-size: 23px; font-weight: 600">
            用户登录
          </p>
          <el-form-item prop="name">
            <el-input v-on:keyup.enter.native="TelLogin('ruleForm')" clearable maxlength="11"
              v-model.trim="ruleForm.name" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="pass" style="margin-bottom: 0">
            <el-input v-on:keyup.enter.native="TelLogin('ruleForm')" clearable show-password type="password"
              maxlength="16" v-model.trim="ruleForm.pass" placeholder="请输入密码"></el-input>
          </el-form-item>
          <div class="verify-container">
            <Verify :type="3" :vOffset="5" :barSize="{ width: '100%', height: '40px' }" explain="向右滑动完成验证" @success="handleCaptchaSuccess" @error="handleCaptchaError"></Verify>
          </div>
          <!-- 忘记密码 -->
          <el-form-item style="margin-bottom: 0">
            <el-button size="mini" type="text" class="ForgetPwd" @click="ForgetPwd(ruleForm.name)">忘记密码？</el-button>
            <el-dialog title="重置密码" :visible.sync="dialogFormVisible" width="500px">
              <el-form :model="ForgetPwdForm" class="ForgetPwdForm" :rules="ForgetPwdrules" ref="ForgetPwdForm"
                status-icon>
                <!-- 手机号 -->
                <el-form-item label="手机号" :label-width="formLabelWidth" prop="name">
                  <el-input clearable v-model="ForgetPwdForm.name" maxlength="11" autocomplete></el-input>
                </el-form-item>
                <!-- 新密码 -->
                <el-form-item label="新密码" :label-width="formLabelWidth" prop="NewPwd">
                  <el-input clearable show-password type="password" maxlength="16" placeholder="请输入新密码"
                    v-model="ForgetPwdForm.NewPwd" autocomplete></el-input>
                </el-form-item>
                <!-- 确认密码 -->
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="ConfirmPwd">
                  <el-input clearable show-password type="password" maxlength="16" placeholder="确认密码"
                    v-model="ForgetPwdForm.ConfirmPwd" autocomplete></el-input>
                </el-form-item>
                <!-- 验证码 -->
                <el-form-item label="验证码" :label-width="formLabelWidth" style="margin-bottom: 0" prop="Code">
                  <el-input clearable maxlength="6" style="width: 180px; margin-right: 10px"
                    v-model.trim="ForgetPwdForm.Code" autocomplete></el-input>
                  <el-button type="text" size="mini" :disabled="isSend" @click="ObtainVerificationCode">{{ codeName
                  }}</el-button>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="ResetPwd('ForgetPwdForm')">确 定</el-button>
              </div>
            </el-dialog>
          </el-form-item>
          <!-- 登录按钮 -->
          <el-form-item>
            <el-button type="primary" @click="TelLogin('ruleForm')" class="LoginBtn">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-denglu"></use>
              </svg>
              账号登录</el-button>
            <!-- <el-divider content-position="center"
              >或者使用其他方式登录</el-divider
            >
            <el-button @click="wxLogin" class="LoginBtn">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-weixin"></use>
              </svg>
              微信登录</el-button
            > -->
            <!-- <el-button
              @click="RegisterAccount"
              style="margin-top: 10px; margin-left: 0"
              class="LoginBtn"
            >
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-zhuce"></use>
              </svg>
              注册账号</el-button
            > -->
            <p style="
                color: gray;
                font-size: 12px;
                text-align: center;
                margin: 0;
              ">
              我同意并遵守服务协议
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <a target="_blank" href="https://beian.miit.gov.cn/" style="
        text-decoration: none;
        position: absolute;
        bottom: 1%;
        width: 100%;
        text-align: center;
        color: gray;
        font-size: smaller;
      ">
      粤ICP备2026020001号-1 
    </a>
  </div>
</template>
<script>
import "@/assets/iconfont/iconfontSymbol.js";
import * as auth from "@/utils/auth";
import Verify from 'vue2-verify'
import {
  CheckTelNumber,
  Login,
  ChangePwd,
  ResetPwd,
  ResetPwdCode,
  // AddLoginInformation,
  // WxLoginToken,
  // WxLogin,
  // test,
} from "@/api/index.js";
export default {
  name: "Login",
  data() {
    // 手机号验证
    var isMobileNumber = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入手机号");
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        const isPhone = reg.test(value);
        value = Number(value); //转换为数字
        if (typeof value === "number" && !isNaN(value)) {
          //判断是否为数字
          value = value.toString(); //转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入手机号"));
        }
      }
    };
    // 密码验证
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    var Code = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    // 重设密码
    let ResetNewPwd = (rule, value, callback) => {
      // let reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);|| !reg.test(value)
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("请输入含8-16位密码"));
      } else {
        if (this.ForgetPwdForm.ConfirmPwd !== "") {
          this.$refs.ForgetPwdForm.validateField("ConfirmPwd");
        }
        callback();
      }
    };
    // 重设密码二次验证
    let ResetConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ForgetPwdForm.NewPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      logo: "/logo.png",
      ruleForm: {
        name: "",
        pass: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入账号", trigger: "blur" },
          // { validator: isMobileNumber, trigger: "blur" },
        ],
        pass: [{ validator: validatePass, trigger: "blur" }],
      },
      dialogFormVisible: false,
      ForgetPwdForm: {
        name: "",
        Code: "",
        NewPwd: "",
        ConfirmPwd: "",
      },
      ForgetPwdrules: {
        name: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        Code: [{ validator: Code, trigger: "blur" }],
        NewPwd: [{ required: true, validator: ResetNewPwd, trigger: "blur" }],
        ConfirmPwd: [
          { required: true, validator: ResetConfirmPwd, trigger: "blur" },
        ],
      },
      captchaPassed: false,
      waitingLogin: false,
      pendingLoginForm: "",
      formLabelWidth: "120px",
      isSend: false, //禁用
      codeName: "发送验证码",
      totalTime: 60, //一般是60
      timer: "", //定时器 
    };
  },
  methods: {
    // 验证码校验
    submitLogin() {
      Login(this.ruleForm.name, this.ruleForm.pass)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.message,
              type: "success",
            });
            localStorage.setItem("token", res.data.token);
            auth.setAdminInfo(res);
            this.$router.push({ path: "/" });
          } else {
            this.$message({
              message: res.message || "登录失败！请检查账号密码是否正确",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "登录异常！",
            type: "error",
          });
          console.log(err);
        });
    },
    // 验证码验证成功
    handleCaptchaSuccess() {
      this.captchaPassed = true; 
      if (this.waitingLogin && this.pendingLoginForm) {
        this.waitingLogin = false;
        this.submitLogin();
      }
    },
    // 验证码错误
    handleCaptchaError(error) {
      this.captchaPassed = false;
      this.waitingLogin = false;
      if (error && typeof error.refresh === "function") {
        error.refresh();
      }
    },
    // 忘记密码时自动获取当前输入手机号
    ForgetPwd(name) {
      this.$message({
        message: "请联系网站管理员重置密码！",
        type: "warning",
      });
      // this.dialogFormVisible = true;
      // let myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      // if (!myreg.test(name)) {
      //   this.ForgetPwdForm.name = "";
      // } else {
      //   this.ForgetPwdForm.name = name;
      // }
    },
    // 重置密码获取验证码接口
    ResetPwdCode() {
      ResetPwdCode(this.ForgetPwdForm.name).then((res) => {
        if (res.Code == "OK") {
          this.$message({
            message: "验证码已发送！",
            type: "success",
          });
        } else {
          this.$message({
            message: res.Message + "；请联系管理员处理！",
            type: "error",
          });
        }
      });
    },
    // 重置密码验证码
    ObtainVerificationCode() {
      let myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.ForgetPwdForm.name)) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
      } else if (this.ForgetPwdForm.name == "13888888888") {
        this.$message({
          message: "该账号为测试账号，无法发送验证码！",
          type: "error",
        });
        return;
      } else {
        CheckTelNumber(this.ForgetPwdForm.name).then((res) => {
          if (res == "ordinary") {
            this.$message({
              type: "error",
              message: "此号码非管理员用户！",
            });
          } else if (res == "error") {
            this.$message({
              type: "error",
              message: "未查询到该手机号，请检查手机号是否在小程序中注册过！",
            });
          } else {
            if (this.isSend) return;
            this.ResetPwdCode(); // 获取验证码的接口
            this.isSend = true;
            this.codeName = this.totalTime + "s后重新发送";
            this.timer = setInterval(() => {
              this.totalTime--;
              this.codeName = this.totalTime + "s后重新发送";
              if (this.totalTime < 0) {
                clearInterval(this.timer);
                this.codeName = "重新发送";
                this.totalTime = 10;
                this.isSend = false;
              }
            }, 1000);
          }
        });
      }
    },
    // 用户登录
    TelLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.captchaPassed) {
            this.submitLogin();
          } else {
            this.waitingLogin = true;
            this.pendingLoginForm = formName;
            this.$message({
              message: "请先完成验证码验证，验证成功后将自动登录",
              type: "warning",
            });
          }
        } else {
          return false;
        }
      });
    },
    // 微信登录
    wxLogin() {
      this.$message({
        message: "微信登录暂未开通 请使用账号登录！",
        type: "warning",
      });
      // WxLoginToken(
      //   "wx641c66a2ccb9d21f",
      //   "3de4a819c21d5bd491a663f51e69e906"
      // ).then((res) => {
      //   console.log(res.access_token);
      //   WxLogin({
      //     data: res.access_token,
      //     headers: { "Content-Type": "application/json" },
      //   }).then((test) => {
      //     console.log(res.access_token);
      //     console.log(test);
      //   });
      // });
      // test().then((res) => {
      //   console.log(res);
      // });
    },
    // 注册账号
    RegisterAccount() {
      this.$prompt("请输入手机号", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
        inputErrorMessage: "手机号格式不正确",
      })
        .then((TelValue) => {
          CheckTelNumber(TelValue.value).then((res) => {
            if (res == "ordinary") {
              this.$message({
                type: "error",
                message: "此号码非管理员用户！",
              });
            } else if (res == "success") {
              this.$prompt("请输入密码", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
              })
                .then((PwdValue) => {
                  ChangePwd(TelValue.value, PwdValue.value).then((res) => {
                    if (res == "success") {
                      this.$message({
                        type: "success",
                        message:
                          "注册成功！你的手机号是: " +
                          TelValue.value +
                          "，你的密码是: " +
                          PwdValue.value +
                          "，请妥善保管！",
                      });
                    } else {
                      this.$message({
                        type: "error",
                        message: "注册失败！",
                      });
                    }
                  });
                })
                .catch(() => { });
            } else if (res == "error") {
              this.$message({
                type: "error",
                message:
                  "未查询到该手机号，请检查手机号是否在小程序中注册过！",
              });
            } else if (res == "registered") {
              this.$message({
                type: "warning",
                message: "该手机号已注册！",
              });
            }
          });
        })
        .catch(() => { });
    },
    // 重置密码
    ResetPwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          ResetPwd(
            this.ForgetPwdForm.name,
            this.ForgetPwdForm.Code,
            this.ForgetPwdForm.ConfirmPwd
          ).then((res) => {
            if (res == "success") {
              this.$message({
                type: "success",
                message: "重置密码成功！",
              });
            } else if (res == "CodeErr") {
              this.$message({
                type: "error",
                message: "验证码错误或已过期！",
              });
            } else {
              this.$message({
                type: "error",
                message: "重置密码失败！",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //Tips() {
    //  this.$alert("系统维护中...", "提示", {
    //     confirmButtonText: "确定",
    //   });
    // },
  },
  watch: {},
  mounted() {
    //如果已经登录则跳转到首页
    if (auth.getAdminInfo("adminInfo").code == 200) {
      this.$router.push({ path: "/" });
    }
    // this.Tips();
  },
  components: { Verify }  // 局部注册
};
</script>
<style scoped lang="less"> 
.verify-container{
  margin-top: 20px;
}
::v-deep .verify-btn {
  display: none;
}
::v-deep .verify-msg {
  font-size: 14px;
  color: gray;
}
.login-container {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 800px;
  display: flex;
  flex-direction: row;
  /* 子元素横向排列 */
  justify-content: center;
  /* 相对父元素水平居中 */
  align-items: center;
  height: 600px !important;
  margin: auto;

  .login-form {
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;

    .el-input {
      width: 250px;
    }

    .LoginBtn {
      width: 100%;
      background-color: #e1edfd;
      border-color: #e1edfd;
      height: 50px;
      color: #2e3749;
      font-weight: 900;
      padding: 0;
    }

    .ForgetPwdForm {
      .el-form-item {
        margin-bottom: 20px;
      }
    }

    .icon {
      width: 1em;
      height: 1em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
      font-size: 25px;
      vertical-align: middle;
    }
  }
}

.el-divider__text {
  padding: 0;
  width: 130px;
  text-align: center;
  font-size: 12px;
  color: gray;
}

.ForgetPwd {
  background-color: transparent;
  border: 0;
  padding: 0;
  border-radius: 0;
  float: right;
  margin: 10px 0;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #409eff;
    border-bottom: 1px solid #409eff;
    transition: background-size 1300ms;
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
